import React from "react";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";

/**
 * SidebarMenu - Sol menü navigasyon bileşeni
 * NavbarMenu'den bağımsız olarak çıkartıldı.
 */
const SidebarMenu = ({
  activeKey,
  permissions,
  isAdmin,
  userInfo,
  activeMenutabContainer,
  activeSubMenutabContainer,
}) => {
  // Service ID 26 için abonelik sayfasını gizle
  const hideSubscription = userInfo && userInfo.service_id === 26;
  const userHasNewServicePermission = permissions.includes('new service');
  const userHasNewCustomerPermission = permissions.includes('new customer');
  const userHasNewVehiclePermission = permissions.includes('new vehicle');
  const userHasNewOfferPermission = permissions.includes('new offer');
  const userHasViewMenuServicesPermission = permissions.includes('view menu services');
  const userHasViewMenuCustomersPermission = permissions.includes('view menu customers');
  const userHasViewMenuVehiclesPermission = permissions.includes('view menu vehicles');
  const userHasViewMenuOffersPermission = permissions.includes('view menu offers');
  const userHasViewMenuSettingsPermission = permissions.includes('view menu settings');
  const userHasViewMenuAppsPermission = permissions.includes('view menu apps');
  const userHasViewMenuReportsPermission = permissions.includes('view menu reports');
  const userHasViewMenuServiceReportsPermission = permissions.includes('view menu service reports');
  const userHasViewMenuCustomerReportsPermission = permissions.includes('view menu customer reports');
  const userHasViewMenuCalendarPermission = permissions.includes('view menu calendar');
  const userHasViewMenuTaskBarPermission = permissions.includes('view menu taskbar');
  const userHasViewMenuBusinessSPermission = permissions.includes('view menu busines settings');
  const userHasViewMenuEmailAndSmsSPermission = permissions.includes('view menu email and sms setting');
  const userHasViewMenuNotificationPPermission = permissions.includes('view menu notification prefers');
  const userHasViewMenuSubscPermission = permissions.includes('view menu subscription');
  const userHasViewMenuRolesPermission = permissions.includes('view menu roles');
  const userHasViewMenuUsersPermission = permissions.includes('view menu users');
  const userHasViewMenuServiceStatusPermission = permissions.includes('view menu service status');
  const userHasViewMenuServiceTypesPermission = permissions.includes('view menu service types');
  const userHasViewMenuIncomeExpensePermission = permissions.includes('view menu income and expense');
  const userHasViewMenuIncomePermission = permissions.includes('view menu income');
  const userHasViewMenuExpensePermission = permissions.includes('view menu expense');
  const userHasViewMenuExpenseIncomeCategoriesPermission = permissions.includes('view expense income category');
  const userHasNewReceivablePermission = permissions.includes('new receivable');
  const userHasViewMenuReceivablePermission = permissions.includes('view menu receivable');
  const userHasViewMenuReceivableReportPermission = permissions.includes('view menu finance receivable report');
  const userHasViewMenuFserviceReportPermission = permissions.includes('view menu finance service report');
  const userHasViewMenuIncomeExpenseReportPermission = permissions.includes('view menu finance income expense report');
  const userHasViewMenuNotificationPermission = permissions.includes('view menu notifications');
  const userHasViewMenuInvoicesPermission = permissions.includes('view menu invoices');
  const userHasViewMenuServicesInvoicesPermission = permissions.includes('view services invoices');
  const userHasViewMenuInboxInvoicePermission = permissions.includes('view inbox invoices');
  const userHasViewMenuCreditInvoicesPermission = permissions.includes('view invoice credit');
  const userHasViewMenuConfPermission = permissions.includes('view menu conf');
  const userHasViewAppointmentPermission = permissions.includes('view appointment');

  return (
    <Nav id="left-sidebar-nav" className="sidebar-nav">
      <ul id="main-menu" className="metismenu">
        {/* Dashboard */}
        <li className={activeKey === "dashboard" ? "active" : ""}>
          <Link to="/dashboard">
            <i className="icon-home"></i> <span>Dashboard</span>
          </Link>
        </li>

        {/* Uygulamalar */}
        {userHasViewMenuAppsPermission ? (
          <li id="AppContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("AppContainer"); }}>
              <i className="icon-grid"></i> <span>Uygulamalar</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "search-parts" ? "active" : ""}>
                <Link to="/search-parts">İnternet Parça Arama</Link>
              </li>
              {userHasViewMenuCalendarPermission ? (
                <li className={activeKey === "appcalendar" ? "active" : ""}>
                  <Link to="/appcalendar">Takvim</Link>
                </li>
              ) : ""}
              {userHasViewMenuTaskBarPermission ? (
                <li className={activeKey === "apptaskbar" ? "active" : ""}>
                  <Link to="/apptaskbar">İş Akış Panosu</Link>
                </li>
              ) : ""}
            </ul>
          </li>
        ) : ""}

        {/* Servisler */}
        {userHasViewMenuServicesPermission ? (
          <li id="ServicesContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("ServicesContainer"); }}>
              <i className="icon-wrench"></i> <span>Servisler</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "services" ? "active" : ""}>
                <Link to="/services">Araç Servisleri</Link>
              </li>
              {userHasViewAppointmentPermission ? (
                <li className={activeKey === "appointments" ? "active" : ""}>
                  <Link to="/appointments">Randevular</Link>
                </li>
              ) : ""}
              {userHasNewServicePermission ? (
                <li className={activeKey === "service-add-ai" ? "active" : ""}>
                  <Link to="/service-add-ai">Yeni servis kaydı</Link>
                </li>
              ) : ""}
            </ul>
          </li>
        ) : ""}

        {/* Müşteri ve Tedarikçiler */}
        {userHasViewMenuCustomersPermission ? (
          <li id="CustomerContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("CustomerContainer"); }}>
              <i className="icon-users"></i> <span>Müşteri ve Tedarikçiler</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "customers-all" ? "active" : ""}>
                <Link to="/customers-all">Müşteriler</Link>
              </li>
              <li className={activeKey === "suppliers" ? "active" : ""}>
                <Link to="/suppliers">Tedarikçiler</Link>
              </li>
              {userHasNewCustomerPermission ? (
                <li className={activeKey === "customer-add" ? "active" : ""}>
                  <Link to="/customer-add">Yeni Müşteri/Tedarikçi</Link>
                </li>
              ) : ""}
            </ul>
          </li>
        ) : ""}

        {/* Mesajlar */}
        {userHasViewMenuCustomersPermission ? (
          <li className={activeKey === "messages" ? "active" : ""}>
            <Link to="/messages">
              <i className="icon-bubble"></i> <span>Mesajlar</span>
            </Link>
          </li>
        ) : ""}

        {/* Araçlar */}
        {userHasViewMenuVehiclesPermission ? (
          <li id="VehicleContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("VehicleContainer"); }}>
              <i className="fa fa-car font-weight-lighter"></i> <span>Araçlar</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "vehicles" ? "active" : ""}>
                <Link to="/vehicles">Araçlar</Link>
              </li>
              {userHasNewVehiclePermission ? (
                <li className={activeKey === "vehicle-add" ? "active" : ""}>
                  <Link to="/vehicle-add">Yeni Araç Ekle</Link>
                </li>
              ) : ""}
            </ul>
          </li>
        ) : ""}

        {/* Teklifler — plan kontrolü kaldırıldı */}
        {userHasViewMenuOffersPermission ? (
          <li id="OfferContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("OfferContainer"); }}>
              <i className="icon-envelope-letter"></i> <span>Teklifler</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "offers" ? "active" : ""}>
                <Link to="/offers">Tüm Teklifler</Link>
              </li>
              {userHasNewOfferPermission && (
                <li className={activeKey === "offer-add" ? "active" : ""}>
                  <Link to="/offer-add">Yeni Teklif Ekle</Link>
                </li>
              )}
            </ul>
          </li>
        ) : ""}

        {/* Gelir Gider Takibi */}
        {userHasViewMenuIncomeExpensePermission ? (
          <li id="IncomeExpenseContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("IncomeExpenseContainer"); }}>
              <i className="icon-notebook"></i> <span>Gelir Gider Takibi</span>
            </a>
            <ul className="collapse">
              {userHasViewMenuExpenseIncomeCategoriesPermission ? (
                <li className={activeKey === "income-expense-categories" ? "active" : ""}>
                  <Link to="/income-expense-categories">Kategoriler</Link>
                </li>
              ) : ""}
              {userHasViewMenuIncomePermission ? (
                <li className={activeKey === "incomes" ? "active" : ""}>
                  <Link to="/incomes">Gelirler</Link>
                </li>
              ) : ""}
              {userHasViewMenuExpensePermission ? (
                <li className={activeKey === "expenses" ? "active" : ""}>
                  <Link to="/expenses">Giderler</Link>
                </li>
              ) : ""}
            </ul>
          </li>
        ) : ""}

        {/* Finansal İşlemler — plan kontrolü kaldırıldı */}
        {userHasViewMenuReceivablePermission && (
          <li id="ReceivableContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("ReceivableContainer"); }}>
              <i className="icon-wallet"></i> <span>Finansal İşlemler</span>
            </a>
            <ul className="collapse">
              {/* Müşteri İşlemleri Sub-Menu */}
              <li id="CustomerTransactionsSubContainer" className="">
                <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeSubMenutabContainer("ReceivableContainer", "CustomerTransactionsSubContainer"); }}>
                  <span>Müşteri İşlemleri</span>
                </a>
                <ul className="collapse">
                  {userHasViewMenuReceivablePermission && (
                    <li className={activeKey === "receivables" ? "active" : ""}>
                      <Link to="/receivables">Cari Hareketler</Link>
                    </li>
                  )}
                  {userHasNewReceivablePermission && (
                    <li className={activeKey === "receivable-add" ? "active" : ""}>
                      <Link to="/receivable-add">Yeni Cari Oluştur</Link>
                    </li>
                  )}
                </ul>
              </li>

              {/* Tedarikçi İşlemleri Sub-Menu */}
              <li id="SupplierTransactionsSubContainer" className="">
                <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeSubMenutabContainer("ReceivableContainer", "SupplierTransactionsSubContainer"); }}>
                  <span>Tedarikçi İşlemleri</span>
                </a>
                <ul className="collapse">
                  {userHasViewMenuReceivablePermission && (
                    <li className={activeKey === "receivables-suppliers" ? "active" : ""}>
                      <Link to="/receivables-suppliers">Cari Hareketler</Link>
                    </li>
                  )}
                  {userHasNewReceivablePermission && (
                    <>
                      <li className={activeKey === "receivable-supplier-add" ? "active" : ""}>
                        <Link to="/receivable-supplier-add">Yeni Cari Oluştur</Link>
                      </li>
                      <li className={activeKey === "supplier-payment-add" ? "active" : ""}>
                        <Link to="/supplier-payment-add">Ödeme Yap</Link>
                      </li>
                    </>
                  )}
                </ul>
              </li>

              {/* Banka Hesapları */}
              <li className={activeKey === "bank-accounts" ? "active" : ""}>
                <Link to="/bank-accounts">Banka Hesapları</Link>
              </li>
            </ul>
          </li>
        )}

        {/* Bildirimler — plan kontrolü kaldırıldı */}
        {userHasViewMenuNotificationPermission && (
          <li id="NotificationsContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("NotificationsContainer"); }}>
              <i className="icon-bell"></i> <span>Bildirimler</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "notifications" ? "active" : ""}>
                <Link to="/notifications">Gönderilen Bildirimler</Link>
              </li>
              <li className={activeKey === "app-notifications" ? "active" : ""}>
                <Link to="/app-notifications">Gelen Bildirimler</Link>
              </li>
            </ul>
          </li>
        )}

        {/* Yeni Rapor Merkezi */}
        {userHasViewMenuReceivablePermission && <li className={activeKey === 'labor-commissions' ? 'active' : ''}>
          <Link to="/labor-commissions"><i className="icon-briefcase" /> <span>İşçilik Hakedişleri</span></Link>
        </li>}
        {userHasViewMenuReportsPermission ? (
          <li id="ReportsV2Container" className={activeKey === "reports-center" ? "active" : ""}>
            <Link to="/reports-center">
              <i className="icon-pie-chart"></i> <span>Rapor Merkezi</span>
              <span className="badge badge-primary ml-2">Yeni</span>
            </Link>
          </li>
        ) : ""}

        {/*
          Eski rapor navigasyonu geri dönüş ihtiyacı için kodda tutuluyor.
          Yeni Rapor Merkezi doğrulandıktan sonra ayrı bir temizlik çalışmasıyla kaldırılabilir.
        */}
        {false && userHasViewMenuReportsPermission ? (
          <li id="ReportsContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("ReportsContainer"); }}>
              <i className="icon-bar-chart"></i> <span>Raporlar</span>
            </a>
            <ul className="collapse">
              {userHasViewMenuServiceReportsPermission ? (
                <li className={activeKey === "service-reports" ? "active" : ""}>
                  <Link to="/service-reports">Servis Raporları</Link>
                </li>
              ) : ""}

              <li id="FinanceReportsSubContainer" className="">
                <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); e.stopPropagation(); activeSubMenutabContainer("ReportsContainer", "FinanceReportsSubContainer"); }}>
                  <span>Finans Raporları</span>
                </a>
                <ul className="collapse">
                  {userHasViewMenuFserviceReportPermission ? (
                    <li className={activeKey === "finance-reports" ? "active" : ""}>
                      <Link to="/finance-reports">Servis Raporu</Link>
                    </li>
                  ) : ""}
                  {userHasViewMenuReceivableReportPermission ? (
                    <li className={activeKey === "finance-receivable-report" ? "active" : ""}>
                      <Link to="/finance-receivable-report">Cari Raporları</Link>
                    </li>
                  ) : ""}
                  {userHasViewMenuIncomeExpenseReportPermission ? (
                    <li className={activeKey === "finance-income-expense-report" ? "active" : ""}>
                      <Link to="/finance-income-expense-report">Gelir ve Gider Raporları</Link>
                    </li>
                  ) : ""}
                </ul>
              </li>

              {userHasViewMenuCustomerReportsPermission ? (
                <li className={activeKey === "customer-reports" ? "active" : ""}>
                  <Link to="/customer-reports">Müşteri Raporları</Link>
                </li>
              ) : ""}

              {/* Stok Raporları */}
              <li id="StockReportsSubContainer" className="">
                <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); e.stopPropagation(); activeSubMenutabContainer("ReportsContainer", "StockReportsSubContainer"); }}>
                  <span>Stok Raporları</span>
                </a>
                <ul className="collapse">
                  <li className={activeKey === "stock/reports/summary" ? "active" : ""}><Link to="/stock/reports/summary">Stok Genel Özet</Link></li>
                  <li className={activeKey === "stock/reports/warehouse" ? "active" : ""}><Link to="/stock/reports/warehouse">Depo Stok Raporu</Link></li>
                  <li className={activeKey === "stock/reports/movements" ? "active" : ""}><Link to="/stock/reports/movements">Stok Hareket Raporu</Link></li>
                  <li className={activeKey === "stock/reports/low-stock" ? "active" : ""}><Link to="/stock/reports/low-stock">Düşük Stok Raporu</Link></li>
                  <li className={activeKey === "stock/reports/sales" ? "active" : ""}><Link to="/stock/reports/sales">Satış Raporu</Link></li>
                </ul>
              </li>
            </ul>
          </li>
        ) : ""}

        {/* Faturalar — plan kontrolü kaldırıldı */}
        {userHasViewMenuInvoicesPermission && (
          <li id="InvoiceContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("InvoiceContainer"); }}>
              <i className="icon-doc"></i> <span>Faturalar</span>
            </a>
            <ul className="collapse">
              {/* Servis Faturaları Sub-Menu */}
              {userHasViewMenuServicesInvoicesPermission && (
                <li id="ServiceInvoiceSubContainer" className="">
                  <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeSubMenutabContainer("InvoiceContainer", "ServiceInvoiceSubContainer"); }}>
                    <span>Servis Faturaları</span>
                  </a>
                  <ul className="collapse">
                    <li className={activeKey === "service-invoices" ? "active" : ""}>
                      <Link to="/service-invoices">Giden Faturalar</Link>
                    </li>
                    {userHasViewMenuInboxInvoicePermission && (
                      <li className={activeKey === "documents" ? "active" : ""}>
                        <Link to="/documents">Gelen Kutusu</Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}

              {/* Manuel Faturalar Sub-Menu */}
              <li id="ManualInvoiceSubContainer" className="">
                <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeSubMenutabContainer("InvoiceContainer", "ManualInvoiceSubContainer"); }}>
                  <span>Manuel Faturalar</span>
                </a>
                <ul className="collapse">
                  <li className={activeKey === "manual-invoices" ? "active" : ""}>
                    <Link to="/manual-invoices">Fatura Listesi</Link>
                  </li>
                  <li className={activeKey === "manual-invoice" ? "active" : ""}>
                    <Link to="/manual-invoice">Yeni Manuel Fatura</Link>
                  </li>
                </ul>
              </li>

              {/* Kontör İşlemleri */}
              {userHasViewMenuCreditInvoicesPermission && (
                <li className={activeKey === "credits" ? "active" : ""}>
                  <Link to="/credits">Kontör İşlemleri</Link>
                </li>
              )}
            </ul>
          </li>
        )}

        {/* Stok Yönetimi */}
        <li id="StockContainer" className="">
          <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("StockContainer"); }}>
            <i className="icon-layers"></i> <span>Stok Yönetimi</span>
          </a>
          <ul className="collapse">
            <li className={activeKey === "stock/warehouses" ? "active" : ""}><Link to="/stock/warehouses">Depolar</Link></li>
            <li className={activeKey === "stock/items" ? "active" : ""}><Link to="/stock/items">Stok Kalemleri</Link></li>
            <li className={activeKey === "stock/categories" ? "active" : ""}><Link to="/stock/categories">Ana Kategoriler</Link></li>
            <li className={activeKey === "stock/movements" ? "active" : ""}><Link to="/stock/movements">Stok Hareketleri</Link></li>
            <li className={activeKey === "stock/transfers" ? "active" : ""}><Link to="/stock/transfers">Transferler</Link></li>
          </ul>
        </li>

        {/* Yapılandırmalar */}
        {userHasViewMenuConfPermission ? (
          <li id="ConfigureContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("ConfigureContainer"); }}>
              <i className="icon-equalizer"></i> <span>Yapılandırmalar</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "branches" ? "active" : ""}><Link to="/branches">Şubeler</Link></li>
              {userHasViewMenuServiceTypesPermission ? (
                <li className={activeKey === "status" ? "active" : ""}><Link to="/status">Servis Durumları</Link></li>
              ) : ""}
              {userHasViewMenuServiceStatusPermission ? (
                <li className={activeKey === "operation-types" ? "active" : ""}><Link to="/operation-types">Servis Tipleri</Link></li>
              ) : ""}
              {userHasViewMenuUsersPermission ? (
                <li className={activeKey === "users" ? "active" : ""}><Link to="/users">Kullanıcılar</Link></li>
              ) : ""}
              {userHasViewMenuRolesPermission ? (
                <li className={activeKey === "settings/roles" ? "active" : ""}><Link to="/settings/roles">Yetkiler</Link></li>
              ) : ""}
            </ul>
          </li>
        ) : ""}

        {/* Admin */}
        {isAdmin && (
          <li id="AdminContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("AdminContainer"); }}>
              <i className="icon-shield"></i> <span>Admin</span>
            </a>
            <ul className="collapse">
              <li className={activeKey === "admin/pricing-management" ? "active" : ""}><Link to="/admin/pricing-management">Fiyatlandırma Yönetimi</Link></li>
              <li className={activeKey === "admin/campaign-management" ? "active" : ""}><Link to="/admin/campaign-management">Kampanya Yönetimi</Link></li>
              <li className={activeKey === "admin/vehicle-avatars" ? "active" : ""}><Link to="/admin/vehicle-avatars">Araç Avatar</Link></li>
              <li className={activeKey === "admin/vehicle-brands" ? "active" : ""}><Link to="/admin/vehicle-brands">Marka & Model Yönetimi</Link></li>
            </ul>
          </li>
        )}

        {/* Ayarlar — QR Kod plan kontrolü kaldırıldı */}
        {userHasViewMenuSettingsPermission ? (
          <li id="SettingsContainer" className="">
            <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("SettingsContainer"); }}>
              <i className="icon-settings"></i> <span>Ayarlar</span>
            </a>
            <ul className="collapse">
              {userHasViewMenuSubscPermission && !hideSubscription ? (
                <li className={activeKey === "settings/subscription" || activeKey === "settings/subscription/detail" ? "active" : ""}>
                  <Link to="/settings/subscription/detail">Üyelik</Link>
                </li>
              ) : ""}
              {userHasViewMenuBusinessSPermission ? (
                <li className={activeKey === "settings/business" ? "active" : ""}>
                  <Link to="/settings/business">İşletme Ayarları</Link>
                </li>
              ) : ""}
              <li className={activeKey === "settings/qr-generate" ? "active" : ""}>
                <Link to="/settings/qr-generate">Qr Kod Oluştur</Link>
              </li>
              {userHasViewMenuEmailAndSmsSPermission ? (
                <li className={activeKey === "settings/notifications" ? "active" : ""}>
                  <Link to="/settings/integration-accounts">Entegrasyon Hesapları</Link>
                </li>
              ) : ""}
              {userHasViewMenuNotificationPPermission ? (
                <li className={activeKey === "settings/notification-prefers" ? "active" : ""}>
                  <Link to="/settings/notification-prefers">Bildirim Tercihleri</Link>
                </li>
              ) : ""}
            </ul>
          </li>
        ) : ""}

        {/* Destek */}
        <li id="TicketContainer" className="">
          <a href="#!" className="has-arrow" onClick={(e) => { e.preventDefault(); activeMenutabContainer("TicketContainer"); }}>
            <i className="icon-info"></i> <span>Destek</span>
          </a>
          <ul className="collapse">
            <li className={activeKey === "tickets" ? "active" : ""}>
              <Link to="/tickets">Destek Talepleri</Link>
            </li>
            <li className={activeKey === "ticket-add" ? "active" : ""}>
              <Link to="/ticket-add">Yeni Destek Talebi</Link>
            </li>
          </ul>
        </li>
      </ul>
    </Nav>
  );
};

export default SidebarMenu;
